// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__HC2Tv","endGameButtons":"sidebar_endGameButtons__+dXQ-","btn":"sidebar_btn__TfACn"};